import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BussinessTypeService {


constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/businessType";

  newBusinessType(tagesStatus: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, tagesStatus)
  }

  businessType(Page: number, size: number, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  getAllBusinessDropDown(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?type=${type}`);
  }

  businessSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }

  syncbusinessData() {
    return this.http.get(`${this.url}/page/sync`);
  }

  public responseCache = new Map();

  public getAllbusinessDropDownCache(type: any): Observable<any> {

    const dealStagesFromCache = this.responseCache.get(`${this.url}/dropdown?type=${type}`);

    if (dealStagesFromCache) {
      return of(dealStagesFromCache);
    } else {
      return this.http.get<any>(`${this.url}/dropdown?type=${type}`).pipe(
        tap(leadStatus => this.responseCache.set(`${this.url}/dropdown?type=${type}`, leadStatus))
      );
    }

  }

    isLoading = new Subject<boolean>();
  
    show() {
      this.isLoading.next(true);
      
    }
  
}
